import { render, staticRenderFns } from "./consulta-projeto.html?vue&type=template&id=2909fc29&"
import script from "./consulta-projeto.js?vue&type=script&lang=js&"
export * from "./consulta-projeto.js?vue&type=script&lang=js&"
import style0 from "./consulta-projeto.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports